<ng-container *ngIf="worksheets$ | withLoading | async as worksheets">
  <ng-container *ngIf="worksheets.data">
    @if(hasItems){
    <fgb-video-gallery [videos]="worksheets.data" />

    }

    <div class="container">
      <div *ngFor="let worksheetGroup of worksheets.data">
        <ng-container *ngIf="!isTV">
          <h2 class="card-header fw-bold border-0 px-2 pb-0">
            {{ 'worksheet.activity.sheets' | translate }}
          </h2>
        </ng-container>

        <ng-container *ngIf="worksheetGroup.Items?.length > 0">
          <div [class.row]="isList">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Download">
                <div [class.col-lg-4]="isList">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="isTV">
          <h2 class="card-header fw-bold border-0 px-2 pb-0">
            {{ 'worksheet.gallery.images' | translate }}
          </h2>
        </ng-container>
        <ng-container *ngIf="!isTV"
          ><h2 class="card-header fw-bold border-0 px-2 pb-0">
            {{ 'worksheet.skill.workshop' | translate }}
          </h2></ng-container
        >
        <div [class.row]="isList">
          <ng-container *ngFor="let item of worksheetGroup.Items">
            <ng-container *ngIf="item.WorksheetType == worksheetType.Gallery || item.WorksheetType == worksheetType.Link">
              <div [class.col-lg-4]="isList">
                <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item></div
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- No Data available -->
  <ng-container *ngIf="worksheets.isEmpty"> <p>No worksheet available</p></ng-container>

  <!-- Error -->
  <ng-container *ngIf="worksheets.error">
    <p>Error {{ worksheets.error }}</p>
  </ng-container>

  <!-- Loading -->
  <ng-container *ngIf="worksheets.isLoading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
</ng-container>
